import { h } from "omi";

import { LoginPage } from "@/wc/pages/login";

export type LoginModalData = {};

export const LoginModal = () => {
  return <LoginPage></LoginPage>;
};
